'use client';

import Script from 'next/script';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

interface BaseStructuredData {
  '@context': string;
  '@type': string;
  name: string;
  alternateName: string;
  publisher: {
    '@type': string;
    name: string;
    url: string;
  };
}

interface StructuredDataScriptProps {
  origin: string;
  baseData: BaseStructuredData;
}

export default function StructuredDataScript({ origin, baseData }: StructuredDataScriptProps) {
  const pathname = usePathname();

  useEffect(() => {
    const structuredData = {
      ...baseData,
      url: `${origin}${pathname}`,
    };

    const existingScript = document.getElementById('structuredData-script');
    if (existingScript) {
      existingScript.textContent = JSON.stringify(structuredData, null, 2);
    }
  }, [pathname]);

  return <Script id={'structuredData-script'} type={'application/ld+json'} />;
}
